import Vue from "vue"
import Vuetify from "vuetify/lib/framework"
import colors from "vuetify/es5/util/colors"

Vue.use(Vuetify)

export default new Vuetify({
  font: {
    family: "Inter"
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      dark: {
        primary: "#0190ea",
        secondary: "#757575",
        accent: "#000000",
        error: "#ff1744",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#ff9800",
        card: "#151515",
        toolbar: "#191919",
        sheet: "#151515",
        text: "#000000",
        dark: "#151515",
        bg: "#121212"
      },
      light: {
        primary: "#0190ea",
        secondary: "#757575",
        accent: "#000000",
        error: "#ff1744",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#ff9800",
        card: "#dedede",
        toolbar: "#dedede",
        sheet: "#dedede",
        text: "#000000",
        dark: "#dedede",
        bg: "#e7e7e7"
      }
    }
  }
})
